<div class="attachments-section">
    <div class="attachments-header">
        <div class="attachments-label">
            <span>Attachments:</span>
            <div class="attachment-list">
                @for (attachment of attachments; track attachment.id) {
                    <div class="attachment-item">
                        <mat-icon
                            [ngClass]="attachment.color"
                            [matTooltip]="attachment.reason || ''"
                            [matTooltipDisabled]="!attachment.reason"
                            matTooltipClass="attachment-tooltip"
                            [svgIcon]="attachment.icon"
                        ></mat-icon>
                        <span>{{ attachment.name }}</span>
                    </div>
                }
            </div>
        </div>
        <div class="updated-date">
            <span>Updated Date:</span>
            <span class="date-value">{{ analysis.createdAt }}</span>
        </div>
    </div>
</div>
